import { useState } from 'react';
import { PAGE_HEADER_CONSTANTS, BREEDER_PAYMENTS_CONSTANTS } from '../../../constants/common';
import UpcomingPayments from './upcoming-payments/UpcomingPayments';
import PaymentHistory from './payment-history/PaymentHistory';
import './BreederPayments.scss';

const BreederPayments = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState<number>(0);

  return (
    <div className="breeder-payments">
      <div className="breeder-payments__panel">
        <div className="breeder-payments__header">
          <div className="breeder-payments__header-text">
            <h1 className="breeder-payments__title">{PAGE_HEADER_CONSTANTS.BREEDER_PAYMENTS}</h1>
          </div>
          <ul className="breeder-payments__tabs" role="tablist">
            <li className={activeTab === 0 ? 'active' : ''}>
              <button
                type="button"
                role="tab"
                tabIndex={activeTab === 0 ? 0 : -1}
                aria-selected={activeTab === 0}
                onClick={() => setActiveTab(0)}>
                {BREEDER_PAYMENTS_CONSTANTS.UPCOMING_PAYMENTS}
              </button>
            </li>
            <li className={activeTab === 1 ? 'active' : ''}>
              <button
                type="button"
                role="tab"
                tabIndex={activeTab === 1 ? 0 : -1}
                aria-selected={activeTab === 1}
                onClick={() => setActiveTab(1)}>
                {BREEDER_PAYMENTS_CONSTANTS.PAYMENT_HISTORY}
              </button>
            </li>
          </ul>
        </div>
        {activeTab === 0 && <UpcomingPayments />}
        {activeTab === 1 && <PaymentHistory />}
      </div>
    </div>
  );
};

export default BreederPayments;
